import { Injectable } from '@angular/core';
import { StoreServiceBase } from './ecom-storeservicebase';
import { Discount } from '@src/app/ecom-models/discount';

@Injectable()
export class UserServiceBase {
    constructor() { }
    userGuid = '';
    userName = '';
    userDialCode = '';
    userMobile = '';
    userEmail = '';
    clientId = '';
    userMapAddress = '';
    userAddress = '';
    landMark = '';
    userPostalCode = 0;
    userCity = '';
    userCurrentLocationIn = '';
    selectedStoreServiceList: StoreServiceBase[] = [];
    serviceCartStarteddAt: Date;
    serviceCheckoutStartedAt: Date;
    selectedDate: string;
    selectedTime: string;
    hasUnpaidOrder = false;

    surcharges: number[] = [];
    order_level_discount: {};

    order_level_reward?: {};
    loyalties: any[];

    customer_loyalty_pointbase: {};
    reward: {};
    gainedPoints: number;
    spentsPoints: number = 0;
    rewardPkidRedeemed: string;
    lastOrderPkid: number;

    entireReward?: Discount;
}
